import { render, staticRenderFns } from "./AdministrationPage.vue?vue&type=template&id=e6497f10&scoped=true"
import script from "./AdministrationPage.vue?vue&type=script&lang=ts"
export * from "./AdministrationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6497f10",
  null
  
)

export default component.exports